import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import {
  AppBar, Toolbar, IconButton, Hidden, CssBaseline, Menu, MenuItem, ListSubheader,
} from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import LockOutlined from '@material-ui/icons/LockOutlined';
import withStyles from '@material-ui/core/styles/withStyles';
import Notification from '@trdk/style/NotificationBar';
import logo from '../tk-logos/Horisontal standard.svg';
import logoMobile from '../tk-logos/Trondheim kommunevåpen.svg';
import { logout } from '../services/fetch/load-form-service';

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: null,
      logoutError: false,
    };
  }

  render() {
    const {
      classes, isFetchingProfile, hasFetchedProfile, profile,
    } = this.props;
    const { open, logoutError } = this.state;

    return (
      <div>
        <CssBaseline />
        <AppBar className={classes.appBar} position="static" elevation={0}>
          <Toolbar className={classes.appbarContent}>
            <Hidden smUp>
              <Link to="/"><img src={logoMobile} alt="Logo" className={classes.logoMobile} /></Link>
            </Hidden>
            <Hidden xsDown>
              <Link to="/"><img src={logo} alt="Logo" className={classes.logo} /></Link>
            </Hidden>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={e => this.setState({ open: e.currentTarget })}
              color="primary"
              className={classes.iconBtn}
            >
              <AccountCircle className={classes.icon} />
            </IconButton>
            <Menu
              disableAutoFocusItem
              id="menu-appbar"
              anchorEl={open}
              open={Boolean(open)}
              onClose={() => this.setState({ open: null })}
            >
              <ListSubheader>
                <strong>
                  {hasFetchedProfile && `${profile.given_name} ${profile.family_name}` }
                  {isFetchingProfile && <Skeleton />}
                </strong>
              </ListSubheader>
              <MenuItem
                dense
                className={classes.menuItem}
                onClick={() => {
                  logout().catch(() => this.setState({ logoutError: true }));
                }}
              >
                <strong>Logg ut</strong>
                <LockOutlined className={classes.menuIcon} />
              </MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
        {logoutError && <Notification variant="error" message="Det oppstod en feil. Kunne ikke logge ut" />}
      </div>
    );
  }
}

Navbar.propTypes = {
  classes: PropTypes.object.isRequired,
  isFetchingProfile: PropTypes.bool.isRequired,
  hasFetchedProfile: PropTypes.bool.isRequired,
  profile: PropTypes.object.isRequired,

};

const styles = theme => ({
  logo: {
    float: 'left',
    height: '5.4rem',
  },
  logoMobile: {
    float: 'left',
    height: '4.4rem',
  },
  headerText: {
    color: 'white',
    flexGrow: 1,
  },
  iconBtn: {
    marginLeft: 'auto',
    marginRight: '2rem',
  },
  menuItem: {
    minHeight: '2.125rem',
    height: '100%',
    whiteSpace: 'pre-line',
  },
  menuIcon: {
    color: theme.palette.primary.main,
    marginLeft: 'auto',
    display: 'inline-flex',
  },
  appBar: {
    backgroundColor: theme.palette.common.white,
    borderBottom: `1rem solid ${theme.palette.primary.main}`,
  },
  appbarContent: {
    maxWidth: '81.3rem',
    width: '100%',
    margin: 'auto',
  },
  icon: {
    height: '2.2rem',
    width: '2.2rem',
  },
});

export default withStyles(styles)(Navbar);
